// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-container_root__yPWFo","article":"tweet-container_article__zRGIS"};